(function ($) {
// JGA - redo this
  Drupal.behaviors.boutique = {
    attach: function (context, settings) {
    // enable the boutique navigation
      $('a[data^="panel"]').on('click', function(e) {
        e.preventDefault();
        $('.locator .menu a').removeClass('active');
        $(this).addClass('active');
        $('.boutique_tab').addClass('hidden');
        $('.' + $(e.target).attr('data')).removeClass('hidden');
        $('.locator').removeClass('details');
      });

      $('.section-header.active a').on('click', function(e) {
        e.preventDefault();
      });

      $('.selectbox').selectbox();
    }
  };
})(jQuery);

var site = site || {};

site.locator = site.locator || {};
site.locator.ui = site.locator.ui || {};
site.locator.data = site.locator.data || {};

site.locator.map = null; // Google map object
site.locator.mapDir = null; // Google map object
site.locator.markers = []; // Array of google.maps.marker objects, ordered the same way as their corresponding doors in site.locator.resultData.results
site.locator.locationsHtml = []; // Array of HTML snippets for info windows, ordered the same way as their corresponding doors in site.locator.resultData.results
site.locator.resultData = {}; // contains results from doors query.
site.locator.resultData.results = []; // contains ordered results from doors query.
site.locator.infoWindow = null; // google.maps.InfoWindow object
site.locator.infoWindowDir = null; // google.maps.InfoWindow object
site.locator.queryFields = 'DOOR_ID, DOORNAME, EVENT_NAME, EVENT_START_DATE, EVENT_END_DATE, EVENT_IMAGE, EVENT_FEATURES, EVENT_TIMES, SERVICES, STORE_HOURS, ADDRESS, ADDRESS2, STATE_OR_PROVINCE, CITY, REGION, COUNTRY, ZIP_OR_POSTAL, PHONE1, LONGITUDE, LATITUDE';
site.locator.directionsDisplay = null; // google.maps.DirectionsRenderer object
site.locator.markerCounter = 0;

site.locator.defaultCountries = '';
site.locator.queryArgs = '';

// JGA
site.locator.locationData = {};
site.locator.ui.inited = false;

site.locator.ui.getRBs = function () {
  var rb = generic.rb('language');

  site.locator.rb = {
    view_details: rb.get('view_details'),
    store: rb.get('store'),
    address: rb.get('address'),
    phone: rb.get('phone'),
    event_js: rb.get('event_js'),
    search_results: rb.get('search_results'),
    no_criteria: rb.get('no_criteria'),
    search_error: rb.get('search_error')
  };
};

site.locator.getDomNodes = function () {
  var $wrapper = $('.store-locator-v1');

  site.locator.nodes = {
    moreResultsContainer: $('.more-results-container', $wrapper),
    moreResultsButton: $('.more-results.button', $wrapper),
    countryMenu: $('select.country', $wrapper),
    localcountryMenu: $('select.local_country', $wrapper),
    cityMenuIntl: $('select.city_intl', $wrapper),
    stateMenu: $('select.state', $wrapper),
    cityMenu: $('input.city', $wrapper),
    zipMenu: $('input.search', $wrapper),
    doorMenu: $('select.door', $wrapper),
    doorRows: $('.door_row', $wrapper),
    doorWithEventRows: $('.door_row', $wrapper),
    doorWithoutEventRows: $('.door_row', $wrapper),
    searchInput: $('input.search', $wrapper),
    select_text: $('#locator-select', $wrapper),
    distanceMenu: $('select.distance', $wrapper),
    searchBtn: $('a.search.button', $wrapper),
    searchAltTxt: $('.search_alternative_text', $wrapper),
    searchBtnGeo: $('a.geo_search.button', $wrapper),
    searchBtnIntl: $('a#search_button_intl', $wrapper),
    searchPanel: $('fieldset#store-search-controls', $wrapper),
    landingPanel: $('div.locator_landing', $wrapper),
    mapPanel: $('div.locations_map_panel', $wrapper),
    map: $('div#map', $wrapper),
    storeResults: $('div#store_results', $wrapper),
    // eventResults     : $('div#event_results', $wrapper),
    locatorErrors: $('ul.locator_error_messages', $wrapper),
    locatorErrors_intl: $('ul.locator_error_messages_intl', $wrapper),
    dirAddrInput: $('div.directions_form input.address', $wrapper),
    dirCityInput: $('div.directions_form input.dirCity', $wrapper),
    dirStateMenuContainer: $('div.dir_state_container', $wrapper),
    dirStateMenu: $('div.directions_form select.dirState', $wrapper),
    dirCountryMenu: $('select.dirCountry', $wrapper),
    dirDoorInput: $('div.directions_form input.door', $wrapper),
    dirSubmit: $('div.directions_form a.directions_submit', $wrapper),
    dirForm: $('div.directions_form', $wrapper),
    dirResults: $('div.directions_results', $wrapper),
    dirPanel: $('div#locator_directions_panel', $wrapper),
    dirMap: $('div.directions_map_container', $wrapper),
    dirDestination: $('div.destination', $wrapper),
    invalidZip: $('#locator-invalid-zip', $wrapper),
    missingCityUS: $('#locator-missing-city-us', $wrapper),
    missingCityIntl: $('#locator-missing-city-intl', $wrapper),
    dirInvalidAddress: $('#locator-dir-invalid-address', $wrapper),
    dirNoRoute: $('#locator-dir-no-route', $wrapper),
    dirUnknownError: $('#locator-dir-unknown-error', $wrapper),
    localRegionIds: $('#region_ids', $wrapper),
    intllocalRegionIds: $('#intl_region_ids', $wrapper),
    stateContainer: $('.state_container', $wrapper),
    localCountryContainer: $('.local_country_container', $wrapper),
    errors: {
      noSearchTerm: $('ul.error_messages li.no-search-term', $wrapper),
      stateNeeded: $('ul.error_messages li.no-need-state', $wrapper),
      noLocationsFound: $('ul.error_messages li.no-locations-found', $wrapper),
      noStoresFound: $('ul.error_messages li.no-stores-found', $wrapper)
    }
  };

  // Remove the geolocation buttons when it's not available to the browser
  if (!navigator.geolocation || (generic.env.isFF && parseInt($.browser.version) <= 27)) {
    site.locator.nodes.searchBtnGeo.parent('.form_element').detach();
    site.locator.nodes.searchAltTxt.detach();
  }
};

site.locator.ui.getTemplates = function () {
  var temp = {};

  generic.template.get({
    path: '/templates/locator/location_info.tmpl',
    callback: function () {},
    object: temp
  });
  generic.template.get({
    path: '/templates/locator/doors_table.tmpl',
    callback: function () {},
    object: temp
  });
  generic.template.get({
    path: '/templates/locator/door_row.tmpl',
    callback: function () {},
    object: temp
  });
};

site.locator.ui.reset = function () {
  site.locator.nodes.dirAddrInput.val('');
};

/**
 * This function initializes the UI elements of the Store Locator page.
 * It communicates with site.locator.data via events.
 */
site.locator.ui.init = function () {
  if (typeof site.locator.locationData === 'undefined') {
    return; // no location data!
  } else if ($.isEmptyObject(site.locator.locationData)) {
    $.getScript('/locator/store_data.tmpl')
      .done(function (script, textStatus) {
        if (!site.locator.ui.inited) {
          site.locator.ui.inited = true;
          site.locator.ui.init();
        }
      });

    return;
  }
  // set the default countries to the values passed by drupal
  site.locator.defaultCountries = $('#local_countries').val();

  /*
     * This function takes a select menu, removes its options, then adds an option with name="Default" and value = ""
     */
  var _clearMenu = function (menu) {
    // menu[0].options.length = 0;
    // wipe out menu html
    menu.html('');

    // rebuild
    generic.forms.select.addOption({
      menuNode: menu,
      label: menu.attr('title') ? menu.attr('title') : site.locator.nodes.select_text.text(),
      value: ''
    });
  };
  /*
     * Initializes select menus by adding default option and populating the State menu from JSON data in page
     */
  var _initMenus = function () {
    // insert default options

    $([
      site.locator.nodes.countryMenu,
      site.locator.nodes.localcountryMenu,
      site.locator.nodes.cityMenuIntl,
      site.locator.nodes.stateMenu,
      site.locator.nodes.cityMenu,
      site.locator.nodes.doorMenu
    ]).each(function () {
      _clearMenu($(this));
    });

    // Populate the country dropdown for the directions menu
    generic.forms.select.addOption({
      menuNode: site.locator.nodes.dirCountryMenu,
      value: site.locator.defaultCountries
    });

    // 
    // populate local country select first if visible
    for (var country in site.locator.locationData) {
      if (country === '') {
        continue;
      }

      if (site.locator.defaultCountries.indexOf(country) !== -1) {
        if (site.locator.nodes.stateContainer.hasClass('neither')) { // only showing city filter...
          for (var state in site.locator.locationData[country]) {
            // if ( state == "" ) { continue; }
            for (var city in site.locator.locationData[country][state]) {
              generic.forms.select.addOption({
                menuNode: site.locator.nodes.cityMenu,
                value: city
              });
            }
          }
        } else if (!site.locator.nodes.stateContainer.hasClass('state')) { // showing local country filter...
          generic.forms.select.addOption({
            menuNode: site.locator.nodes.localcountryMenu,
            value: country
          });
        } else { // showing state
          for (var state in site.locator.locationData[country]) {
            if (state === '') {
              continue;
            }
            generic.forms.select.addOption({
              menuNode: site.locator.nodes.stateMenu,
              value: state
            });
          }
        }
      } else {
        generic.forms.select.addOption({
          menuNode: site.locator.nodes.countryMenu,
          value: country
        });
        generic.forms.select.addOption({
          menuNode: site.locator.nodes.dirCountryMenu,
          value: country
        });
      }
    }

    site.locator.nodes.countryMenu.val(site.locator.nodes.countryMenu.data('country-selected'));

    _refreshSelect($('.selectbox', site.locator.nodes.searchPanel));
  };
  var _localcountryMenuChangeHandler = function (stateNode, cityNode) {
    _clearMenu(stateNode);
    _clearMenu(cityNode);

    // populate state drop-down if visible, otherwise populate city drop-down
    if (!site.locator.nodes.stateContainer.hasClass('country')) {
      for (var state in site.locator.locationData[site.locator.nodes.localcountryMenu.val()]) {
        if (state === '') {
          continue;
        }
        generic.forms.select.addOption({
          menuNode: stateNode,
          value: state
        });
      }
      stateNode.focus();
    } else {
      var cities = {};

      for (var state in site.locator.locationData[site.locator.nodes.localcountryMenu.val()]) {
        jQuery.extend(cities, site.locator.locationData[site.locator.nodes.localcountryMenu.val()][state]);
      }
      _filterCityMenu(cityNode, cities);
      _sortSelect(cityNode);
      cityNode.focus();
    }
    _refreshSelect(stateNode);
    _refreshSelect(cityNode);
  };
  var _countryMenuChangeHandler = function (cityNode) {
    var cities = {};

    for (var state in site.locator.locationData[site.locator.nodes.countryMenu.val()]) {
      jQuery.extend(cities, site.locator.locationData[site.locator.nodes.countryMenu.val()][state]);
    }
    _filterCityMenu(cityNode, cities);
    cityNode.focus();
  };
  /*
     * Event handler for onchange event on State menu
     */
  var _stateMenuChangeHandler = function () {
    _filterDoorMenu();
    site.locator.nodes.doorMenu.focus();
  };
  /*
     * Reads value from state menu and populates city menu with the appropriate values, based on JSON data in page
     */
  /*
     * Sort select options in alphabetical order
     */
  var _sortSelect = function (selectNode) {
    var listitems = selectNode.children('option').get();

    listitems.sort(function (a, b) {
      return $(a).text().toUpperCase() === 'SELECT' ? -1 : $(a).text().toUpperCase().localeCompare($(b).text().toUpperCase());
    });
    $.each(listitems, function (idx, itm) {
      selectNode.append(itm);
    });
  };
  /*
     * Event handler for onchange event on City menu
     */
  var _cityMenuChangeHandler = function () {
    _filterDoorMenu();
    site.locator.nodes.doorMenu.focus();
  };
  /*
     * Reads value from city menu and populates door (store) menu with the appropriate values, based on JSON data in page
     */
  var _filterDoorMenu = function (doorNode, locationData) {
    _clearMenu(site.locator.nodes.doorMenu);
    var storeArray = [];
    var country = $('#local_countries').val();
    var state = site.locator.nodes.stateMenu.val();

    for (var city in site.locator.locationData[country][state]) {
      var city = city;

      storeArray = site.locator.locationData[country][state][city];
      for (var i = 0, len = storeArray.length; i < len; i++) {
        generic.forms.select.addOption({
          menuNode: site.locator.nodes.doorMenu,
          value: storeArray[i]
        });
      }
    }
    _refreshSelect(site.locator.nodes.doorMenu);
  };
  /*
     * Event handler for click of Doors search button
     */
  var _searchClickHandler = function () {
    site.locator.ui.reset();
    var country = 'Australia';
    var state = site.locator.nodes.stateMenu.val();
    var city = site.locator.nodes.cityMenu.val();
    var zip = site.locator.nodes.zipMenu.val();
    var distance = site.locator.nodes.distanceMenu.val();

	  site.locator.nodes.errors.stateNeeded.addClass('inactive');
	  site.locator.nodes.errors.noSearchTerm.addClass('inactive');
	  site.locator.nodes.errors.noLocationsFound.addClass('inactive');
	  site.locator.nodes.errors.noStoresFound.addClass('inactive');
	  city = $.trim(city);
	  var cityRegEx = new RegExp(/^[a-z ]+$/i);
	  var validcity = cityRegEx.test(city);

    if (zip.length !== 0 || (city.length !== 0 && state.length !== 0 && validcity)) {
      // get current content from main search text field, and run it through the geocoder

	 var addresses = city && state ? city + ' ' + state : zip ? zip : '';
      // var addresses = (city && state) ? city + " " + state : (state) ? state : (zip) ? zip + ' AU' : '';		
      var geocoder = new google.maps.Geocoder();

      geocoder.geocode({
        'address': addresses,
        'componentRestrictions': { 'country': country }
      }, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          if (addresses) {
            filteredResults = site.locator.geocodeResultFilter(results);
          }
          // Handle country searches.
          if (addresses) {
            filteredResults = results;
            country_all = country;
          }

          site.locator.nodes.storeResults.addClass('hidden');
		      site.locator.nodes.moreResultsContainer.addClass('hidden');

          if (filteredResults && filteredResults.length > 0 && results[0].formatted_address != country) {
            site.locator.nodes.moreResultsContainer.removeClass('hidden');
			      site.locator.nodes.storeResults.removeClass('hidden');
            _searchBaseHandler(results[0].geometry.location.lat(), results[0].geometry.location.lng(), distance, country_all);
            site.locator.addressDisplayData = results[0].formatted_address;
            site.locator.foundLocationData = results;
            site.locator.remainingLocationData = results.slice(1);
          } else {
            site.locator.nodes.errors.noLocationsFound.removeClass('inactive');
            site.locator.nodes.searchPanel.removeClass('loading');
          }
        } else {
          site.locator.nodes.errors.noLocationsFound.removeClass('inactive');
		  site.locator.nodes.searchPanel.removeClass('loading');
        }
      });
    } else {
      site.locator.nodes.errors.noSearchTerm.removeClass('inactive');
    }
  };
  var _searchGeoClickHandler = function () {
    site.locator.ui.reset();
    site.geo.locate(function (args) {
      var door = site.locator.nodes.doorMenu.val();
      var distance = site.locator.nodes.distanceMenu.val();
      var storeList = [];

      if (!!door) {
        if (door.length > 0) {
          storeList[0] = door;
          queryArgs.params[0].show_stores_list = storeList;
        }
      }

      // find the containing zip code, then send the query
      var geocoder = new google.maps.Geocoder();
      var latlng = new google.maps.LatLng(args.lat, args.lng);

      geocoder.geocode({ 'latLng': latlng }, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          (function () {
            for (var i = 0; i < results.length; i += 1) {
              for (var j = results[i].address_components.length - 1; j >= 0; j -= 1) {
                if (results[i].address_components[j].types.length === 1 && results[i].address_components[j].types[0] === 'postal_code') {
                  _searchBaseHandler(args.lat, args.lng);
                  site.locator.queryArgs.addressDisplayData = results[i].address_components[j].long_name;

                  return;
                }
              }
            }
          }());
        } else {
          // set some sort of fail status
        }
      });
    });
  };
  /*
     * Collects parameters from form input elements, packs them into parameters,
     * then passes them to search query via the "locator:submitSearchQuery" event.
     * @see site.locator.data.submitQuery
     */
  var _searchBaseHandler = function (lat, lng, distance, country) {
    var queryArgs = {
      params: [
        {
          'fields': site.locator.queryFields,
          'radius': distance || site.locator.nodes.distanceMenu.val(),
          // "country" : country,
          'latitude': lat,
          'uom': 'mile',
          'longitude': lng,
		  'show_stores_list': site.locator.nodes.doorMenu.val()
        }
      ]
    };

    queryArgs.callback = function () {
      site.locator.ui.displayMap();

      site.locator.ui.displayResultsTable();
    };

    $(document).trigger('locator.submitSearchQuery', [queryArgs]);

    site.locator.queryArgs = queryArgs;
  };
  var _refreshSelect = function ($selects) {
    $selects.each(function () {
      var $select = $(this);

      $select.selectbox('detach');
      $select.selectbox();
      $select.css('display', 'none');
    });
  };

  _initMenus();

  // prepopulate search field with form-submitted search value, if we're passed one, then submit
  var presubmittedSearch = generic.env.query('search');

  if (presubmittedSearch) {
    site.locator.nodes.searchInput.val(decodeURIComponent(presubmittedSearch).replace('+', ' '));
  }

  site.locator.nodes.countryMenu.on('change', function (e) {
    _countryMenuChangeHandler(site.locator.nodes.cityMenuIntl);
  });
  site.locator.nodes.cityMenu.on('change', function (e) {
    _cityMenuChangeHandler();
  });
  site.locator.nodes.stateMenu.on('change', function (e) {
    _stateMenuChangeHandler();
  });
  site.locator.nodes.searchBtn.on('click', function (e) {
    _searchClickHandler();
  });

  site.locator.nodes.searchBtnGeo.on('click', function (e) {
    _searchGeoClickHandler();
  });

  site.locator.nodes.searchInput.on('keydown', function (e) {
    if (e.keyCode == 13) {
      _searchClickHandler();
    }
  });

  site.locator.ui.displayMap();

  // if we'd previously found a search term coming to us through the query string, and
  // have put it in our search field... trigger the click event, so that it's submitted
  if (presubmittedSearch) {
    site.locator.nodes.searchBtn.trigger('click');
  }
  // if ($.browser.msie) {
  //   // Select boxes are positioned wrong in IE 8 when opened, seemingly because $(window).scrollTop() is always 0.
  //   // Oddly this is not an issue in IE 7.
  //   $('.selectBox').selectbox().on('beforeopen', function() {
  //     if (document.documentElement.scrollTop != $(window).scrollTop()) {
  //       var options = $(this).data('selectBox-control').data('selectBox-options');
  //       options.css('top', parseInt(options.css('top').replace('px', '')) + document.documentElement.scrollTop);
  //       options.css('top', parseInt(options.css('top').replace('px', '')) + document.documentElement.scrollTop + 'px');
  //     }
  //   });
  // }
};

/*
 * This function fetches the JS template: /templates/locator/location_info.tmpl
 * and uses it to create the info windows that are displayed when clicking on a pointer image on the map.
 */
site.locator.ui.buildLocationHtml = function (args) {
  generic.template.get({
    path: '/templates/locator/location_info.tmpl',
    object: args.locationData,
    callback: function (html) {
      args.callback(html);
    }
  });
};

/*
 * This function builds the table of result data. It loads the JS template: /templates/locator/door_row.tmpl.
 * The site.locator.resultData.results Array must be populated.
 */
site.locator.ui.displayResultsTable = function () {
  var tbody = null;
  var buildRow = function (doorData, idx) {
    doorData.index_number = idx;
    doorData.display_number = idx + 1;
    doorData.index_letter = site.locator.ui.getImageIndex(idx);
    doorData.distanceFormatted = parseFloat(doorData.DISTANCE).toFixed(2);
    doorData.distanceFormatted = isNaN(doorData.distanceFormatted) ? 'Unknown' : doorData.distanceFormatted;

    if (doorData.EVENT_START_DATE && doorData.EVENT_END_DATE) {
      var event_start = new Date(doorData.EVENT_START_DATE.replace(/-/g, ' '));
      var event_end = new Date(doorData.EVENT_END_DATE.replace(/-/g, ' '));

      // PBruno: the check for the year has to  do with JS 1.2 backwards compatibility,
      // which would in some instances spit out a four-digit full year, for all
      // years not in 1900-1999; I just check for any four digit value for year,
      // and if I find one, leave it alone (forego adding the 1900)
      doorData.EVENT_DATE = event_start.getMonth() + 1 + '/' + event_start.getDate() + '/' + (event_start.getYear() < 1000 ? parseInt(event_start.getYear()) + 1900 : event_start.getYear());
      doorData.EVENT_DATE += ' - ';
      doorData.EVENT_DATE += event_end.getMonth() + 1 + '/' + event_end.getDate() + '/' + (event_end.getYear() < 1000 ? parseInt(event_end.getYear()) + 1900 : event_end.getYear());

      var hasEvent = true;

      if (doorData.EVENT_IMAGE) {
        var image_path_parts = doorData.EVENT_IMAGE.split('.');

        image_path_parts[0] += '_lrg';
        doorData.EVENT_LARGE_IMAGE = image_path_parts.join('.');
      }
    }

    generic.template.get({
      path: '/templates/locator/door_row.tmpl',
      object: doorData,
      callback: function (html) {
        var idx = doorData.index_number;
        var node = $(html);

        if (doorData.COUNTRY != site.locator.defaultCountry) {
          node.find('.directions').hide();
        }
        tbody.append(node);
        var row = tbody.find('tr.door_row_' + idx);

        if (idx >= 10) {
          row.addClass('hidden');
        }
        site.locator.nodes.doorRows.add(row);
        if (hasEvent) {
          site.locator.nodes.doorWithEventRows.add(row);

          row.find('.event-details a.view-details').on('click', function (e) {
            e.preventDefault();
            generic.template.get({
              path: '/templates/locator/doors_event_popup.tmpl',
              object: doorData,
              callback: function (html) {
                var content = $(html);

                content.filter('.event-large-image').error(function () {
                  $(this).css('display', 'none');
                });
                generic.overlay.launch({
                  content: content,
                  includeBackground: true,
                  includeCloseLink: true,
                  cssClass: 'store-locator-popup-v1',
                  cssStyle: {
                    width: '700px',
                    padding: '25px'
                  }
                });
                addthisevent.refresh();
              }
            });
          });
        } else {
          row.find('.event-details > *').css('display', 'none');
          site.locator.nodes.doorWithoutEventRows.add(row);
        }
        var markerLink = row.find('a.marker');

        markerLink.on('click', function () {
          site.locator.ui.launchInfoWindow(idx);
          $('html, body').animate({ scrollTop: 0 }, 'slow');
        });

        var directionsLink = $('a.search_button.directions_link').eq(idx);

        directionsLink.on('click', function (evt) {
          evt.preventDefault();
          window.open('https://www.google.com.au/maps/dir//' + parseFloat(doorData.LATITUDE) + ',' + parseFloat(doorData.LONGITUDE) + '/', '_blank');
          // old code for directions link
          /*
                    //site.locator.showStore(doorData);
                    site.locator.ui.displayMap(true, idx);
                    site.locator.ui.launchInfoWindow(idx);

                    site.locator.getDomNodes();
                    _initDirectionsForm();
                    site.locator.ui.resetDirections();
                    google.maps.event.trigger(site.locator.mapDir, 'resize');
                    //$('.selectbox', site.locator.nodes.dirPanel).selectbox('destroy');
                    //$('.selectbox', site.locator.nodes.dirPanel).selectbox().selectbox('settings', { menuTransition: 'slide', menuSpeed: 'fast' });
                    generic.template.get({
                        path:'/templates/locator/destination_address.tmpl',
                        object: doorData,
                        callback: function(html) {
                          site.locator.nodes.dirDestination.html(html);
                        }
                    });
                    site.locator.nodes.dirDoorInput.val(doorData.DOOR_ID);
                    // site.locator.ui.initDirectionsForm(doorData);
                    */
        });
      }
    });
  };

  generic.template.get({
    path: '/templates/locator/doors_table.tmpl',
    callback: function (html) {
      site.locator.nodes.storeResults.html(html);
      tbody = site.locator.nodes.storeResults.find('tbody');
      // resultData.results.each( function(doorID, idx) {
      //     buildRow(locations[doorID], idx);
      // });
      if (site.locator.queryArgs.params !== undefined && site.locator.queryArgs.params.length) {
        var totalResults = site.locator.resultData.sortedResults.length,
          params = site.locator.queryArgs.params[0],
          searchCriteria = [],
          paramKeys = ['state', 'city'];

        if (site.locator.addressDisplayData) {
          searchCriteria.push(site.locator.addressDisplayData);
          site.locator.addressDisplayData = null;
        } else if (params['zip'] !== '' && params['zip'] !== undefined) {
          searchCriteria.push(params['zip']);
        } else if (site.locator.queryArgs.addressDisplayData) {
          searchCriteria.push(site.locator.queryArgs.addressDisplayData);
        } else {
          for (var i = 0; i < paramKeys.length; i++) {
            var paramKey = paramKeys[i];

            if (params[paramKey] !== undefined) {
              searchCriteria.push(params[paramKey]);
            }
          }
        }
        var searchQuery = $.trim(searchCriteria.join(' '));
        var $resultCountNode = totalResults == 1 ? $('.results-count-singular') : $('.results-count-plural'),
          $otherCountNode = totalResults == 1 ? $('.results-count-plural') : $('.results-count-singular');

        $resultCountNode.html($resultCountNode.text().replace('::count::', '<span class="count">' + totalResults + '</span>').replace('::query::', '<span class="query">' + searchQuery + '</span>')).show();
      }
      var i = 0;

      for (var d in site.locator.resultData.sortedResults) {
        buildRow(site.locator.resultData.sortedResults[d], i);
        i++;
      }
      site.locator.nodes.moreResultsContainer.addClass('hidden');
      if (i >= 10) {
        site.locator.nodes.moreResultsContainer.removeClass('hidden');
        site.locator.nodes.moreResultsButton.on('click', function(e) {
          e.preventDefault();
          $('.door_row.hidden').removeClass('hidden');
          $('.map-marker.hidden').removeClass('hidden');
          site.locator.nodes.moreResultsContainer.addClass('hidden');
        });
      }
      addthisevent.refresh();
      omnidata = [searchQuery, totalResults];
      tms_page_data.tms_page_info['STORELOCATOR'] = omnidata;
      jQuery(window).trigger('STORELOCATOR', [omnidata]);
    }
  });

  /*
     * Initializes the Driving Directions form. Populates State menu. On form submit,
     * the starting address values are concatenated and passed to the data query method
     * via the "locator:submitDirectionsQuery" event.
     */
  var _initDirectionsForm = function () {
    site.locator.nodes.dirSubmit.on('click', function (evt) {
      var args = {
        startAddress: site.locator.nodes.dirAddrInput.val()
      };
      var doorId = site.locator.nodes.dirDoorInput.val();

      args.doorData = site.locator.resultData.results[doorId];
      $(document).trigger('locator.submitDirectionsQuery', [args]);
    });
  };
  var _clearMenu = function (menu) {
    menu[0].innerHTML = '';
    generic.forms.select.addOption({
      menuNode: menu,
      label: menu.attr('title') ? menu.attr('title') : site.locator.nodes.select_text.text(),
      value: ''
    });
  };

  site.locator.nodes.searchPanel.removeClass('loading');
};

site.locator.ui.getImageIndex = function (num) {
  var ltr = String.fromCharCode('A'.charCodeAt(0) + num);

  return ltr;
};

/*
 * Convenience funtion that builds the path to custom pointer images.
 * Images should be named map_marker_[capital letter].png and placed in /media/export/images/locator.
 * @returns {string} relative path to image, e.g., /media/export/images/locator/map_marker_B.png
 */
site.locator.ui.getMarkerImagePath = function (num) {
  var ltr = site.locator.ui.getImageIndex(num);

  return generic.env.domain + '/sites/clinique/themes/cl_base/img/locator/map-marker-' + ltr + '.png';
};

/*
 * This function encapsulates the various calls to the Google Maps API that render
 * the map of results. It initializes a google.maps.Map object (storing it in site.locator.map),
 * adds markers, and sets up the event handler for clicking on the markers.
 * The site.locator.resultData.results Array must be populated.
 */
site.locator.ui.displayMap = function (directions, i) {
  var results = i === 0 || i ? [i] : site.locator.resultData.results;
  var mapNode = directions ? site.locator.nodes.dirMap : site.locator.nodes.map;

  // if there are no results, center the map on the US, display the map, and just return
  if (!results || results.length === 0) {
    var mapOptions = {
      zoom: 4,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: false,
      navigationControl: true,
      mapTypeControl: false,
      scaleControl: true
    };
    var map = new google.maps.Map(mapNode[0], mapOptions);
    var geocoder = new google.maps.Geocoder();

    geocoder.geocode({ 'address': 'AU' }, function (results, status) {
      var ne = results[0].geometry.viewport.getNorthEast();
      var sw = results[0].geometry.viewport.getSouthWest();

      map.fitBounds(results[0].geometry.viewport);
    });
    mapNode.show();

    return;
  }

  // if we're here, there is result data, proceed accordingly
  var zoomLevel = directions ? 15 : 12;
  var mapOptions = {
    zoom: zoomLevel,
    center: new google.maps.LatLng(site.locator.resultData.latitude, site.locator.resultData.longitude),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    disableDefaultUI: false,
    navigationControl: true,
    mapTypeControl: false,
    scaleControl: true
  };
  var map = new google.maps.Map(mapNode[0], mapOptions);

  if (directions) {
    site.locator.mapDir = map;
  } else {
    site.locator.map = map;
  }

  // site.locator.nodes.landingPanel.hide();
  mapNode.show();

  if (!directions) {
    var idx = 0;

    for (var d in results) {
      if (idx > 20) {
        break;
      }
      //
      // place markers on Google Map
      var location = site.locator.resultData.sortedResults[idx];
      var lat = location.LATITUDE;
      var lng = location.LONGITUDE;
      var latLng = new google.maps.LatLng(location.LATITUDE, location.LONGITUDE);
      var marker = site.locator.MapLocationIcon({
        id: '',
        latlng: latLng,
        label: idx + 1,
        icon_class: idx >= 10 ? 'hidden' : '',
        map: map,
        clickHandler: (function (idx) {
          return function () {
            site.locator.ui.launchInfoWindow(idx);
          };
        }(idx))
      });

      // var zIndex = 20 - idx;
      // marker.setZIndex(zIndex);

      site.locator.markers[idx] = marker;
      //
      // build info window
      location.idx = idx;
      site.locator.ui.buildLocationHtml({
        locationData: location,
        callback: function (html) {
          site.locator.locationsHtml[idx] = html;
          //
          // display info window on first location
          if (idx === 0) {
            site.locator.ui.launchInfoWindow(idx);
          }
        }
      });

      eval("google.maps.event.addListener( marker, 'click', function(e) { site.locator.ui.launchInfoWindow( " + idx + ', ' + directions + ');});');
      //
      // launch info window on click of marker (on map)
      // google.maps.event.addListener( marker, 'click', function(e) {
      //    site.locator.ui.launchInfoWindow(idx);
      // });
      //
      // set map center for first location
      if (idx === 0) {
        map.setCenter(latLng);
      }
      idx++;
    }
  } else {
    var location = site.locator.resultData.sortedResults[i];
    var lat = location.LATITUDE;
    var lng = location.LONGITUDE;
    var latLng = new google.maps.LatLng(location.LATITUDE, location.LONGITUDE);
    var marker = new google.maps.Marker({
      icon: markerPath,
      map: map,
      position: latLng
    });

    map.setCenter(latLng);
  }
};

/*
 * Displays Info Window for a given marker/door.
 * @param i {Number} index of door/marker for which info window should be displayed
 * @param directions {bool} if true indicates we're launching on the directions map rather than the main one
 */
site.locator.ui.launchInfoWindow = function (i, directions) {
  if (directions) {
    var map = site.locator.mapDir;
    // site.locator.infoWindowDir = new google.maps.InfoWindow();
  } else {
    var map = site.locator.map;

    if (!site.locator.infoWindow) {
      site.locator.infoWindow = new google.maps.InfoWindow({ pixelOffset: new google.maps.Size(0, -44) });
    }
    var infoWindow = site.locator.infoWindow;

    infoWindow.setContent(site.locator.locationsHtml[i]);
    infoWindow.open(map, site.locator.markers[i]);
  }
  // site.locator.markers[i].setZIndex(site.locator.markerCounter + 100);
  site.locator.markerCounter++;
};

/*
 * Callback function for "locator:directionsLoaded" event.
 * Hides Directions form and displays Directions results table.
 * Passes directions query response to google.maps.DirectionsRenderer object.
 * @param response {Object} response from Google Maps directions query
 */
site.locator.ui.displayDirections = function (response) {
  // site.locator.nodes.dirForm.addClass("hidden");
  site.locator.nodes.dirResults.removeClass('hidden');
  // miles intead of mi
  // var miles = response.routes[0].legs[0].distance.text;
  // distance = miles.replace('mi','miles');
  // response.routes[0].legs[0].distance.text = distance;
  site.locator.directionsDisplay.setDirections(response);
};

site.locator.ui.resetDirections = function () {
  site.locator.nodes.dirForm.removeClass('hidden');
  site.locator.nodes.dirResults.addClass('hidden');
};

// JS snippet to save the store events to calendar
site.locator.ui.saveToCalendar = function () {
  var outlook_calendar = $('.store-locator-v1 .hidden.outlook_calendar').html();
  var google_calendar = $('.store-locator-v1 .hidden.google_calendar').html();
  var yahoo_calendar = $('.store-locator-v1 .hidden.yahoo_calendar').html();
  var hotmail_calendar = $('.store-locator-v1 .hidden.hotmail_calendar').html();
  var ical_calendar = $('.store-locator-v1 .hidden.ical_calendar').html();
  var facebook_event = $('.store-locator-v1 .hidden.facebook_event').html();

  addthisevent.settings({
    license: 'aptrpsjrpzki5qyxvmue',
    mouse: false,
    css: false,
    outlook: {
      show: true,
      text: outlook_calendar
    },
    google: {
      show: true,
      text: google_calendar
    },
    yahoo: {
      show: true,
      text: yahoo_calendar
    },
    hotmail: {
      show: true,
      text: hotmail_calendar
    },
    ical: {
      show: true,
      text: ical_calendar
    },
    facebook: {
      show: true,
      text: facebook_event
    },
    dropdown: { order: 'outlook,google,yahoo,hotmail,ical,facebook' },
    // callback  : ['fun1()']
    callback: ''
  });
};

$(document).ready(function () {
  site.locator.getDomNodes();
  site.locator.ui.getRBs();
  site.locator.ui.init();
  site.locator.ui.getTemplates();
  site.locator.ui.saveToCalendar();
}); // end dom:loaded

$(document).on('locator.directionsLoaded', function (e, param) {
  site.locator.ui.displayDirections(param);
});

/*
 * This function handles the query submit event. It parses the data from the event memo
 * and passes it to the fetch method. This method should NOT be called directly by a UI method;
 * rather, the params should be passed as part of the memo to the locator:submitSearchQuery event.
 * @param {function} args.callback a function that gets called after door data is returned
 * @param {Array} args.params an Array that contains a hash of parameters that get
 * passed to the JSON-RPC method.
 * @param {Array} args.params[0].fields The data fields to be returned from the JSON-RPC request
 * @param {number} args.params[0].radius The distance from the origin point inside which stores should be returned.
 * @param {string} args.params[0].zip Postal Code of origin point location
 * @param {string} args.params[0].state State of origin point location
 * @param {string} args.params[0].city City of origin point location
 * @param {Array} args.params[0].show_stores_list Array of Store Names by which results should be filtered. Empty array
 * should be passed to return all stores.
 * @example
 * // var queryArgs = {
 * //     params : [{
 * //         fields : "DOOR_ID, DOORNAME, STORE_HOURS, ADDRESS, ADDRESS2, STATE_OR_PROVINCE, CITY",
 * //         radius : 25,
 * //         zip    : "10014",
 * //         state  : "NY",
 * //         city   : "New York"
 * //     }],
 * //     callback : function() {
 * //          site.locator.ui.displayMap();
 * //          site.locator.ui.displayResultsTable();
 * //      }
 * // };
 */
site.locator.data.submitQuery = function (args) {
  var params = args.params;
  var callbackFn = args.callback;
  var zipRegEx = new RegExp(/(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnpstvxy]{1}\d{1}[A-Za-z]{1} ?\d{1}[A-Za-z]{1}\d{1})$/);

  if (!params[0].latitude && !params[0].longitude) {
    jQuery.each(site.locator.nodes.errors, function () {
      this.addClass('inactive');
    });
    site.locator.nodes.errors.noLocationsFound.removeClass('inactive');

    return;
  }

  site.locator.data.fetch({
    data: params,
    onSuccess: function (resultData) {
      resultData.maxDistance = parseFloat(args.params[0].radius);
      if (isNaN(resultData.maxDistance)) {
        resultData.maxDistance = null;
      }
      site.locator.data.setData(resultData);
      if (typeof callbackFn === 'function') {
        callbackFn();
      }
      jQuery.each(site.locator.nodes.errors, function () {
        this.addClass('inactive');
      });
    },
    onFailure: function (jsonRpcResponse) {
      var errorObjectsArray = jsonRpcResponse.getMessages();

      jQuery.each(site.locator.nodes.errors, function () {
        this.addClass('inactive');
      });
      site.locator.nodes.errors.noStoresFound.removeClass('inactive');
    }
  });
};

$(document).on('locator.submitSearchQuery', function (evt, param) {
  site.locator.data.submitQuery(param);
});

/*
 * Callback function that handles response from JSON-RPC request. It filters
 * and sorts the result data, then places the data in the global variable
 * site.locator.resultData.results
 */
site.locator.data.fetch = function (args) {
  generic.jsonrpc.fetch({
    method: 'locator.doorsandevents',
    params: args.data,
    onSuccess: function (r) {
      var resultData = r.getValue();

      args.onSuccess(resultData);
    },
    onFailure: function (r) {
      args.onFailure(r);
    }
  });
};

/*
 * Callback function that handles response from JSON-RPC request. It filters
 * and sorts the result data, then places the data in the global variable
 * site.locator.resultData.results
 */
site.locator.data.setData = function (rawResultData) {
  site.locator.resultData = rawResultData;
  if (rawResultData.maxDistance) { // max distance exists
    var filteredResults = {};

    for (var d in rawResultData.results) {
      if (rawResultData.results[d].DISTANCE < rawResultData.maxDistance) {
        filteredResults[d] = rawResultData.results[d];
      }
    }
    site.locator.resultData.results = filteredResults;
  }

  // asc. sort by distance
  var sortedResults = [];
  var r = site.locator.resultData.results;
  var sortedDoorIds = site.locator.resultData.doors || [];

  function sortByDistance(a, b) {
    var aDist = !r[a].DISTANCE || isNaN(r[a].DISTANCE) ? 0 : parseFloat(r[a].DISTANCE);
    var bDist = !r[b].DISTANCE || isNaN(r[b].DISTANCE) ? 0 : parseFloat(r[b].DISTANCE);

    if (aDist > bDist) {
      return 1;
    } else if (aDist < bDist) {
      return -1;
    }

    return 0;
  }

  sortedDoorIds.sort(sortByDistance);

  for (var i = 0, len = sortedDoorIds.length; i < len; i++) {
    sortedResults.push(site.locator.resultData.results[sortedDoorIds[i]]);
  }
  site.locator.resultData.sortedResults = sortedResults;
};

/*
 * This function retrieves Driving Directions data from Google. The data
 * retrieved is then passed as a memo in the event "locator:directionsLoaded."
 */
site.locator.data.getDirections = function (args) {
  var directionsService = new google.maps.DirectionsService();

  site.locator.directionsDisplay = new google.maps.DirectionsRenderer();

  site.locator.nodes.dirResults.empty();

  site.locator.directionsDisplay.setMap(site.locator.mapDir);
  site.locator.directionsDisplay.setPanel(site.locator.nodes.dirResults[0]);

  var start = args.startAddress;
  var end = args.doorData.ADDRESS + ', ' + args.doorData.CITY + ' ' + args.doorData.ZIP_OR_POSTAL;
  var request = {
    origin: start,
    destination: end,
    travelMode: google.maps.DirectionsTravelMode.DRIVING
  };

  directionsService.route(request, function (response, status) {
    $('.dirError').remove();
    if (status == google.maps.DirectionsStatus.OK) {
      $(document).trigger('locator.directionsLoaded', [response]);
    } else if (status == google.maps.DirectionsStatus.NOT_FOUND) {
      // Couldn't find address, we need to show the user an error message
      $('<ul class="error_messages dirError"><li>' + site.locator.nodes.dirInvalidAddress.text() + '</li></ul>').insertAfter('.directions-header');
    } else if (status == google.maps.DirectionsStatus.ZERO_RESULTS) {
      // No route between locations
      $('<ul class="error_messages dirError"><li>' + site.locator.nodes.dirNoRoute.text() + '</li></ul>').insertAfter('.directions-header');
    } else {
      // Some other error that prevented us from getting directions.
      $('<ul class="error_messages dirError"><li>' + site.locator.nodes.dirUnknownError.text() + '</li></ul>').insertAfter('.directions-header');
    }
  });
};

/*
 * This function loads detail store view
 */
site.locator.showStore = function (args) {
  $('.boutique_tab').addClass('hidden');
  $('.panel_1_1').removeClass('hidden');
  $('.locator').addClass('details');
  $('.panel_1_1 .plaque h2').html(args.DOORNAME);
  $('.panel_1_1 .plaque .city p').html(args.CITY);
  $('.panel_1_1 .plaque .address p').html(args.ADDRESS + '<br />' + args.CITY + '<br />' + args.ZIP_OR_POSTAL);
  $('.panel_1_1 .plaque .phone p').html(args.PHONE1);
  $('.panel_1_1 .plaque .hours p').html(args.STORE_HOURS);
  $(window).scrollTop();

  $('.detail-hero .directions_button').on('click', function(e) {
    e.preventDefault();
    $(window).scrollTo($('.panel_1_1 .section-header'), 500, {
      offset: {
        top: -38,
        left: 0
      }
    });
  });
};

$(document).on('locator.submitDirectionsQuery', function (evt, param) {
  site.locator.data.getDirections(param);
});

var doorDetails = function (index) {
  $('a.search_button.directions_link').eq(index).trigger('click');
};
var doorDetailsDirections = function (index, fromAddress) {
  doorDetails(index);
  $('#locator_directions_panel input.address').val(fromAddress);
  $('.directions_submit').trigger('click');
};

/* Email Signup */
site.locator.emailSignup = {};

site.locator.emailSignup.getDomNodes = function () {
  var container = $('.store-locator-body div.signup');

  site.locator.emailSignup.nodes = {
    container: container,
    errors: container.find('ul.error_messages'),
    panel: container.find('.signup_form_panel'),
    form: container.find('form'),
    formname: container.find('[name="form_name"]'),
    source: container.find('[name="source"]'),
    original_source: container.find('[name="original_source"]'),
    last_source: container.find('[name="last_source"]'),
    email: container.find('[name="email"]'),
    name: container.find('[name="name"]'),
    postcode: container.find('[name="postcode"]'),
    submit: container.find('[type="submit"]'),
    thankyou: container.find('.thankyou'),
    country_id: container.find('[name="country_id"]'),
    pc_email_promotions: container.find('[name="pc_email_promotions"]')
  };
};

site.locator.emailSignup.init = function () {
  var _submitData = function (data) {
    site.locator.emailSignup.nodes.thankyou.hide();
    generic.jsonrpc.fetch({
      method: 'rpc.form',
      params: [data],
      onSuccess: function (r) {
        var result = r.getValue();

        generic.showErrors([], site.locator.emailSignup.nodes.errors, site.locator.emailSignup.nodes.form);
        site.locator.emailSignup.nodes.panel.removeClass('loading').hide();
        site.locator.emailSignup.nodes.thankyou.show();
      },
      onFailure: function (r) {
        var error = r.getError();

        generic.showErrors(error.data.messages, site.locator.emailSignup.nodes.errors, site.locator.emailSignup.nodes.form);
        site.locator.emailSignup.nodes.panel.removeClass('loading');
        site.locator.emailSignup.nodes.thankyou.hide();
      }
    });
  };

  site.locator.emailSignup.nodes.form.on('submit', function () {
    site.locator.emailSignup.nodes.panel.addClass('loading');

    _submitData({
      '_SUBMIT': site.locator.emailSignup.nodes.formname.val(),
      'PC_EMAIL_ADDRESS': site.locator.emailSignup.nodes.email.val(),
      'FIRST_NAME': site.locator.emailSignup.nodes.name.val(),
      'POSTAL_CODE': site.locator.emailSignup.nodes.postcode.val(),
      'LAST_SOURCE': site.locator.emailSignup.nodes.last_source.val(),
      'ORIGINAL_SOURCE': site.locator.emailSignup.nodes.original_source.val(),
      'COUNTRY_ID': site.locator.emailSignup.nodes.country_id.val(),
	  'PC_EMAIL_PROMOTIONS': site.locator.emailSignup.nodes.pc_email_promotions.val()
    });

    return false;
  });
};

$(function () {
  // onload
  site.locator.emailSignup.getDomNodes();
  site.locator.emailSignup.init();
  site.locator.emailSignup.nodes.thankyou.hide();
});
